import { Route, Switch, Redirect } from 'react-router-dom';
import { useFeatureFlag } from 'providers';
import { ROUTES } from 'constants/routes';
import PrivateRoute from 'components/PrivateRoute';
import {
  BlackoutScreen,
  ClaimZs,
  EditProfile,
  Home,
  HowItWorks,
  PerkzStore,
  PerkzWallet,
  Profile,
  ReferAndEarn,
  Signup,
  SurprisePerk,
  Terms,
  ZsActivity,
  WinASlice,
} from 'pages';

const Routes = () => {
  const blackoutScreen = useFeatureFlag('blackoutScreen');
  const disableBlackoutScreen = useFeatureFlag('disableBlackoutScreen');
  const allowWinASlice = useFeatureFlag('allowWinASlice');

  return (
    <Switch>
      {blackoutScreen && !disableBlackoutScreen && <BlackoutScreen />}

      <PrivateRoute path="/" exact component={Home} />
      <PrivateRoute path={ROUTES.PERKZ_WALLET} component={PerkzWallet} />
      <PrivateRoute path={ROUTES.PERKZ_STORE} component={PerkzStore} />
      <PrivateRoute path={ROUTES.CLAIM_ZS} component={ClaimZs} />
      <PrivateRoute path={ROUTES.HOW_IT_WORKS} component={HowItWorks} />
      <PrivateRoute path={ROUTES.PROFILE} exact component={Profile} />
      <PrivateRoute path={ROUTES.PROFILE_EDIT} component={EditProfile} />
      <PrivateRoute path={ROUTES.TERMS_AND_CONDITIONS} component={Terms} />
      <PrivateRoute path={ROUTES.REFER_A_FRIEND} component={ReferAndEarn} />
      <PrivateRoute path={ROUTES.SURPRISE_PERK} component={SurprisePerk} />
      <PrivateRoute path={ROUTES.ZS_ACTIVITY} component={ZsActivity} />
      <PrivateRoute path={ROUTES.TAKEAWAY} component={ClaimZs} />
      <PrivateRoute path={ROUTES.REDEEM_Z_CODE} component={ClaimZs} />
      {allowWinASlice && <PrivateRoute path={ROUTES.WIN_A_SLICE} component={WinASlice} />}

      <Route path={ROUTES.SIGNUP} component={Signup} />

      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
